// Shared <script>-loader promise for the YouTube IFrame Player API, so every
// player on the page (desktop table, mobile table, artist page) waits on one
// script load instead of each racing to set window.onYouTubeIframeAPIReady.

let _ytApiPromise = null;
export function loadYouTubeIframeApi() {
  if (_ytApiPromise) return _ytApiPromise;
  _ytApiPromise = new Promise((resolve) => {
    if (window.YT && window.YT.Player) {
      resolve(window.YT);
      return;
    }
    const prevCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (prevCallback) prevCallback();
      resolve(window.YT);
    };
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(script);
    }
  });
  return _ytApiPromise;
}
